import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getCookieConsent, setCookieConsent, type CookieConsent } from '../posthog';
import IconCookie from './Icon/IconCookie';

const focusRing =
    'focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 dark:focus-visible:ring-primary-light dark:focus-visible:ring-offset-black';

export default function CookieConsentBanner() {
    const { t } = useTranslation();
    const [consent, setConsent] = useState(getCookieConsent);

    if (consent) return null;

    const choose = (choice: CookieConsent) => {
        setCookieConsent(choice);
        setConsent(choice);
    };

    return (
        <div
            role="region"
            aria-labelledby="cookie-consent-message"
            className="fixed inset-x-0 bottom-0 z-[60] px-4 pb-[max(1rem,env(safe-area-inset-bottom))] font-nunito text-sm"
        >
            {/* The animation sits on the panel, not this wrapper: a filter on an ancestor would cut off the panel's backdrop blur. */}
            <div className="panel mx-auto max-w-2xl gap-4 bg-white/95 text-dark motion-safe:animate-rise-in dark:bg-black/90 dark:text-white-dark sm:flex-row sm:items-center">
                <div className="flex flex-1 items-start gap-3 sm:items-center">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary motion-safe:animate-roll-in dark:bg-primary-dark-light dark:text-primary-light">
                        <IconCookie />
                    </span>
                    <p id="cookie-consent-message" className="leading-relaxed">
                        {t('cookie_consent_message')}
                    </p>
                </div>
                <div className="flex shrink-0 gap-2">
                    <button
                        type="button"
                        className={`btn btn-outline-primary btn-sm flex-1 dark:border-primary-light dark:text-primary-light dark:hover:text-white ${focusRing}`}
                        onClick={() => choose('rejected')}
                    >
                        {t('reject')}
                    </button>
                    <button type="button" className={`btn btn-primary btn-sm flex-1 ${focusRing}`} onClick={() => choose('accepted')}>
                        {t('accept')}
                    </button>
                </div>
            </div>
        </div>
    );
}
